import { threeItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const temperatureInversion_ABOVEvsBELOW: typeof valueTypeRenderers.temperatureInversion_ABOVEvsBELOW =
  {
    label: () =>
      translate.phrases.templates('{{labelA}} ({{labelB}})', {
        labelA: unitConverter.temperatureInversion().titleWithoutUnit(),
        labelB: translate.phrases.banyanApp('Above vs Below'),
      }),
    point: () =>
      makeNumberRenderer({
        baseLabel: threeItemLabel([
          unitConverter.temperatureInversion().titleWithoutUnit(),
          translate.phrases.banyanApp('Above vs Below'),
          unitConverter.temperatureInversion().suffix(),
        ]),
        render: (n) => unitConverter.temperatureInversion(n).valueAsString(),
      }),
  }
